import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[(_vm.$route.path !== '/' && _vm.$route.name !== 'Not found')?_c('TopBar'):_vm._e(),_c('router-view'),_c('SnackBar'),_c('Loading'),_c('portal-target',{attrs:{"name":"portal-raiz-projeto"}}),_c('ChatSuporteOctadesk'),(_vm.$route.path !== '/')?_c('Nps'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }